import { useTranslation } from 'react-i18next';
import { Select } from '@knack/asterisk-react';
import { produce } from 'immer';

import { type FilterFormat } from '@/components/data-table/helpers/getRecords';

export function MatchSelector({
  ruleIndex,
  currentFilter,
  setCurrentFilter
}: {
  ruleIndex: number;
  currentFilter: FilterFormat;
  setCurrentFilter: (state: FilterFormat) => void;
}) {
  const [t] = useTranslation();
  const { match } = currentFilter;
  return (
    <div className="min-w-[70px] text-right">
      {ruleIndex === 0 && <p>{t('components.data_table.filtering.when')}</p>}
      {ruleIndex === 1 && (
        <Select
          onValueChange={(matchSelected) => {
            const nextState = produce(currentFilter, (draftState) => {
              draftState.match = matchSelected as 'and' | 'or';
            });

            setCurrentFilter(nextState);
          }}
          defaultValue={match}
        >
          <Select.Trigger
            placeholder={t('components.data_table.filtering.select')}
            className="w-full rounded-lg"
            data-testid="operator-select"
          />
          <Select.Content>
            <Select.Item value="and">{t('components.data_table.filtering.and')}</Select.Item>
            <Select.Item value="or">{t('components.data_table.filtering.or')}</Select.Item>
          </Select.Content>
        </Select>
      )}
      {ruleIndex > 1 && <p>{t(`components.data_table.filtering.${match}`)}</p>}
    </div>
  );
}
